import { useEffect, RefObject } from 'react';

export const useOnClickOutside = (
  {
    ref,
  }: {
    ref: RefObject<any>;
  },
  handler: (event: MouseEvent | TouchEvent) => any
) => {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      if (!ref?.current?.contains(event.target)) {
        handler(event);
      }
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};
